$ = jQuery;
//Dropdown Menu
function dropdownMenu() {
    if ($(window).width() > 320) {
        $('.navbar .menu-item-has-children').hover(function () {
            $(this).find('.sub-menu').first().stop(true, true).delay(250).slideDown();

        }, function () {
            $(this).find('.sub-menu').first().stop(true, true).delay(100).slideUp();

        });

    }
}
// Bootstrap dropdown-toggle clickable
function dropdownToggleClick() {
    $('.navbar .navbar-nav .dropdown-toggle, .guide__menu .navbar-nav .dropdown-toggle').click(function () {
        location.href = this.href;
    });
}

//
function handleNavbarToggler() {
    $('body').on('click', '.navbar-toggler', function () {
        $(this).toggleClass('on');
        $('body').toggleClass('menu-open');
        $('.navbar').toggleClass('open');

    });
}
//
function dropToggler() {
    $('.menu-item-has-children').prepend('<span class="drop-toggler"><i class="fa-solid fa-angle-down"></i></span>');
    $('body').on('click', '.drop-toggler', function () {
        var parentMenuItem = $(this).parent('.menu-item-has-children');
        parentMenuItem.toggleClass('open');
        parentMenuItem.siblings('.menu-item-has-children').removeClass('open');
        $(this).toggleClass('open');
        parentMenuItem.siblings('.menu-item-has-children').find('.drop-toggler').removeClass('open');
    });
}

function stickyNavbar() {
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 350) {
            $(".navbar").addClass("sticky");
        } else {
            $(".navbar").removeClass("sticky");
        }
    });
}

function navHeight() {
    var navHeight = $('.navbar').height() + 'px';
    $('.site-wrapper').css('padding-top', navHeight);
}
navHeight();
$(window).resize(function () {
    navHeight();
});

stickyNavbar();
// dropdownMenu();
dropdownToggleClick();
handleNavbarToggler();
dropToggler();

$('.sub-menu li a').on('click', function(){
    $('.navbar-collapse').collapse('hide');
    $('body').toggleClass('menu-open');
    $('.navbar').toggleClass('open');
    $('.navbar-toggler').toggleClass('on');
});

